// Safely parse a JSON string, return undefined on empty string or parse error
export function parseJSONSafely<T>(json: string): T {
  if (typeof json !== 'string' || json === '') {
    return undefined;
  }
  try {
    let result = JSON.parse(json);
    return result;
  } catch (err) {
    console.error('Can\'t parse JSON', json, err);
    return undefined;
  }
}
